import { render, staticRenderFns } from "./GestorCentralizadoActionsBar.vue?vue&type=template&id=534faf35&"
import script from "./GestorCentralizadoActionsBar.vue?vue&type=script&lang=js&"
export * from "./GestorCentralizadoActionsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports